import { localizeLanguage } from '@/helpers/Meta/metaInfoHelper';
import { BASE_PATH } from '@/router/routes/constants';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { useRoute } from 'vue-router';

export function useRel() {
  const route = useRoute();

  const getLandingPageCanonicalLink = () => {
    return {
      rel: 'canonical',
      href: `${import.meta.env.VUE_APP_BASE_URL}${route.path}`,
    };
  };

  const getLandingPageAlternateLinks = () => {
    return Object.values(HgSupportedLanguage).map((lang) => ({
      rel: 'alternate',
      hreflang: localizeLanguage(lang),
      href: `${import.meta.env.VUE_APP_BASE_URL}${BASE_PATH[lang]}`,
    }));
  };

  const getLandingPageDefaultAlternateLink = () => {
    return {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${import.meta.env.VUE_APP_BASE_URL}${BASE_PATH[HgSupportedLanguage.DE]}`,
    };
  };

  return {
    getLandingPageCanonicalLink,
    getLandingPageAlternateLinks,
    getLandingPageDefaultAlternateLink,
  };
}
